import { render, staticRenderFns } from "./BuyPackage.vue?vue&type=template&id=3b2cc170"
import script from "./BuyPackage.vue?vue&type=script&lang=ts"
export * from "./BuyPackage.vue?vue&type=script&lang=ts"
import style0 from "./BuyPackage.vue?vue&type=style&index=0&id=3b2cc170&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports